$('document').ready(function() {
  $('.two').click(function(){
    $('.quantity-selector input').val('2');
    $('.discounts li').removeClass('active');
    $(this).addClass('active');
  });
  $('.four').click(function(){
    $('.quantity-selector input').val('4');
    $('.discounts li').removeClass('active');
    $(this).addClass('active');
  });
  $('.eleven').click(function(){
    $('.quantity-selector input').val('11');
    $('.discounts li').removeClass('active');
    $(this).addClass('active');
  });

  $('.quantity-selector__button').click(function(){
    $('.discounts li').removeClass('active');
  })

  $('.empty-state .button.button--xl').attr('href',"/");

  $('a:contains("Cookie-Einstellungen")').click(function(e){
    e.preventDefault();
    $('#banner-wrapper').css('visibility','visible');
    $('#banner-wrapper').css('display','flex');
    $('#banner-wrapper').css('opacity','1');
    $('#banner-wrapper').removeAttr('hidden');
  })
})
